// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"b1144e58","107":"a8cef0e9","195":"24d5ef21","206":"d72f6c83","244":"cc1986d2","255":"123ee69f","310":"700f6d3c","324":"3a06896a","399":"77f66438","504":"3fb36a75","510":"6dc51d94","541":"3530739d","596":"96e9d914","691":"41ae0e5e","963":"839c54c1"}[chunkId] + ".chunk.js";
};